import { AssetSelectionBladeModalProps } from 'components/containers/load-board/AssetSelectionBlade.tsx'
import { PaymentRestrictionsBladeProps } from 'components/containers/bills/components/PaymentRestrictionsBlade.tsx'
import { SyncLogInfoBladeProps } from 'components/containers/ledger/components/SyncLogInfo.tsx'
import { AddEditUserBladeProps } from 'components/containers/settings/users/AddEditUserBlade'
import { ConfigureRoleBladeProps } from 'components/containers/settings/roles-and-permissions/ConfigureRoleBlade'

/**
 * @deprecated
 * use FormModalPropsMap instead for simplicity and type safety
 */
const FORM_MODALS: { [key: string]: keyof FormModalPropsMap } = {
  NEW_REGRADE: 'new-regrade-modal',
  NEW_FINISHED_GOOD: 'new-finished-good-modal',
  NEW_PACKING_LIST: 'new-packing-list-modal',
  NEW_ADJUSTMENT: 'new-adjustment-modal',
  PACKING_LIST_CREATED: 'packing-list-created-modal',
  CREATE_ORGANIZATION: 'create-organization-modal',
  NEW_CUSTOMER: 'new-customer-modal',
  BENCHMARK_PRICING: 'benchmark-pricing-modal',
  NEW_MATERIAL: 'new-material-modal',
  NEW_COMMODITY: 'new-commodity-modal',
  FINISHED_GOOD_CREATED: 'finished-good-created-modal',
  LINK_PURCHASE_ORDER: 'link-purchase-order',
  LINK_SALE_ORDER: 'link-sales-order',
  EQUIPMENT_SELECTOR: 'equipment-selector',
  SYNC_LOG_INFO: 'sync-log-info-modal',
  ADD_VEHICLE: 'add-vehicle',
  INVOICE_PAYMENT: 'invoice-payment',
  INVOICE_CONFIRMATION: 'invoice-confirmation',
  INVOICE_PRINT: 'invoice-print',
  SETTINGS: 'settings-modal',
  SELECT_AVAILABLE_TRANSFER: 'select-available-transfer',
  MERGE_TICKETS: 'merge_tickets',
  CREATE_CASH_CARD: 'create-cash-card',
  EDIT_FORMULA: 'edit-formula',
  FREIGHT_LANE_BLADE: 'freight-lane-blade',
  CONTAINER_ASSET_BLADE: 'container-asset-blade',
  TRUCK_ASSET_BLADE: 'truck-asset-blade',
  TRAILER_ASSET_BLADE: 'trailer-asset-blade',
  ASSET_SELECTION_BLADE: 'asset-selection-blade',
  DISPATCH_TICKET_STATUS_BLADE: 'dispatch-ticket-status-blade',
  DISPATCH_TICKET_PREVIEW: 'dispatch-ticket-preview',
  CREATE_FROM_DISPATCH: 'create-from-dispatch',
  MANAGE_DRIVERS_BLADE: 'manage-drivers-blade',
  PAYMENT_RESTRICTIONS_BLADE: 'payment-restrictions-blade',
  DISPATCH_TICKET_IMAGES_BLADE: 'dispatch-ticket-images-blade',
  RECURRING_DISPATCH_TICKET: 'recurring-dispatch-ticket-modal',
}

/**
 * @deprecated no longer necessary now that redux store is typed
 */
type FormModalKey = keyof typeof FORM_MODALS
/**
 * @deprecated no longer necessary now that redux store is typed
 */
export type FormModalValue = (typeof FORM_MODALS)[FormModalKey]

export default FORM_MODALS

/**
 * FormModalPropsMap is a map of form modal names to their props
 * ensures that the props are correctly typed for each respective modal
 */
export interface FormModalPropsMap {
  // as these modals are ported over to TS we can define FormModalProps as needed
  'asset-selection-blade': AssetSelectionBladeModalProps
  'new-customer-modal': any
  'payment-restrictions-blade': PaymentRestrictionsBladeProps
  'invoice-payment': any
  'invoice-confirmation': any
  'invoice-print': any
  'link-sales-order': any
  'dispatch-ticket-status-blade': any
  'sync-log-info-modal': SyncLogInfoBladeProps
  'dispatch-ticket-images-blade': any
  'new-regrade-modal': any
  'new-finished-good-modal': any
  'new-packing-list-modal': any
  'new-adjustment-modal': any
  'packing-list-created-modal': any
  'create-organization-modal': any
  'benchmark-pricing-modal': any
  'new-material-modal': any
  'new-commodity-modal': any
  'finished-good-created-modal': any
  'link-purchase-order': any
  'equipment-selector': any
  'add-vehicle': any
  'settings-modal': any
  'select-available-transfer': any
  merge_tickets: any
  'create-cash-card': any
  'edit-formula': any
  'freight-lane-blade': any
  'container-asset-blade': any
  'truck-asset-blade': any
  'trailer-asset-blade': any
  'dispatch-ticket-preview': any
  'create-from-dispatch': any
  'manage-drivers-blade': any
  'add-edit-user-blade': AddEditUserBladeProps
  'configure-role-blade': ConfigureRoleBladeProps
  'recurring-dispatch-ticket-modal': any
  'link-dispatch-to-obt': any
}
